import { render } from "./CourseExamList.vue?vue&type=template&id=3f5a16f0&scoped=true"
import script from "./CourseExamList.vue?vue&type=script&lang=js"
export * from "./CourseExamList.vue?vue&type=script&lang=js"

import "./CourseExamList.vue?vue&type=style&index=0&id=3f5a16f0&lang=scss&scoped=true"

import exportComponent from "/var/www/html/bcsprostuti-web-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f5a16f0"]])

export default __exports__